function FlashOff({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.4301 8H11.8201L14.1001 10.28L15.4301 8ZM15.4301 0H5.43005V1.61L11.5601 7.74L15.4301 0ZM1.84005 0.86L0.430054 2.27L5.43005 7.27V11H8.43005V20L12.0101 13.85L16.1601 18L17.5701 16.59L1.84005 0.86Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default FlashOff;
